module.exports = __webpack_public_path__ + "img/medals.c3b6685f.png";